import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatChipAvatar, MatChipListbox, MatChipOption, MatChipRemove,} from '@angular/material/chips';
import {MatIcon} from '@angular/material/icon';

import {StateService} from '@app/state/state.service';
import {Observable} from 'rxjs';

import {map} from 'rxjs/operators';
import {FilterData, FilterService} from '../filter.service';

@Component({
    selector: 'frog-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    imports: [
        MatChipListbox,
        MatChipOption,
        MatIcon,
        MatChipAvatar,
        MatChipRemove,
        MatIconButton,
        AsyncPipe,
    ],
})
export class FiltersComponent implements OnInit {
    public filterData$: Observable<FilterData>;

    constructor(
        private stateService: StateService,
        private filterService: FilterService,
    ) {}

    ngOnInit(): void {
        this.filterData$ = this.stateService.state.pipe(map((state) => state.filterData));
    }

    removeSearch() {
        this.filterService.patchFilterData('search', null);
    }

    removeTag(tag: string, tags: string[]) {
        const index = tags.indexOf(tag);
        tags.splice(index, 1);
        if (tags.length === 0) {
            tags = null;
        }
        this.filterService.patchFilterData('tags', tags);
    }

    removeUser(user: string, users: string[]) {
        const index = users.indexOf(user);
        users.splice(index, 1);
        if (users.length === 0) {
            users = null;
        }
        this.filterService.patchFilterData('users', users);
    }

    removeDate(date: string, dates: string[]) {
        const index = dates.indexOf(date);
        dates.splice(index, 1);
        dates = dates.filter((date) => date !== null);
        if (dates.length === 0) {
            dates = null;
        }
        this.filterService.patchFilterData('dates', dates);
    }

    clear() {
        this.filterService.clear();
    }
}
